import { ENV } from '@env';

/**
 * Utility functions for pseudolocalization feature validation
 * TODO : Remove this check as a part of pre-feature release cleanup : https://taserintl.atlassian.net/browse/FWX-3477
 */

/**
 * Checks if pseudolocalization (en-XA) is allowed in the current environment and organization
 * Note: en-XA is now dynamically generated at runtime from en-US.json
 * @param isDemo - Whether the organization is a demo organization
 * @param hasSSO - Whether the user has SSO authentication (optional, defaults to true for service-level checks)
 * @returns true if pseudolocalization is allowed, false otherwise
 */
export function isPseudolocalizationAllowed(isDemo: boolean, hasSSO: boolean = true): boolean {
  return !isProduction() && isDemo && hasSSO;
}

export function isProduction(): boolean {
  const env = (ENV as string).toLowerCase();
  return env.includes('prod') || env.includes('production');
}
